import type { FC } from 'react';
import { Fragment } from 'react';
import ContentLoader from 'react-content-loader';

import { createArray } from 'app/utils/array';

interface Props {
  nbLines?: number;
}

const HEAD_HEIGHT = 14;
const LINE_HEIGHT = 19;
const LINE_OVERROUND = 44;
const DATA_OFFSET = 90;

function getTopPosition(lineIndex: number): number {
  return (LINE_HEIGHT + LINE_OVERROUND) * lineIndex + DATA_OFFSET;
}

function getHeight(nbLines: number): number {
  return (LINE_HEIGHT + LINE_OVERROUND) * (nbLines - 1) + LINE_HEIGHT + DATA_OFFSET;
}

const VideogameTreePlaceholder: FC<Props> = ({ nbLines = 3 }) => (
  <ContentLoader width={1350} height={getHeight(nbLines)}>
    <rect x={33} y={42} width={105} height={HEAD_HEIGHT} />
    <rect x={200} y={42} width={105} height={HEAD_HEIGHT} />
    <rect x={388} y={42} width={105} height={HEAD_HEIGHT} />
    <rect x={576} y={42} width={105} height={HEAD_HEIGHT} />
    <rect x={764} y={42} width={105} height={HEAD_HEIGHT} />

    {createArray(nbLines).map((_, index) => {
      const y = getTopPosition(index);
      return (
        <Fragment key={index}>
          <rect x={30} y={y} width={1105} height={LINE_HEIGHT} />
          <rect x={1204} y={y} width={50} height={LINE_HEIGHT} />
        </Fragment>
      );
    })}
  </ContentLoader>
);

VideogameTreePlaceholder.displayName = 'VideogameTreePlaceholder';

export default VideogameTreePlaceholder;
